import { BadgeCheck, Phone, Mail, Facebook, Instagram } from "lucide-react";
import HotdogIcon from "./HotdogIcon";
import { CONTACT, SOCIAL } from "@/lib/data";

export default function Footer({ onNavigate }) {
    return (
        <footer id="kontakt" data-testid="footer" className="relative bg-poelse-deep text-paper">
            <div className="checker h-3" />
            <div className="mx-auto flex max-w-6xl flex-col gap-10 px-5 py-16 sm:flex-row sm:items-start sm:justify-between">
                <div className="max-w-sm">
                    <div className="flex items-center gap-2.5">
                        <span className="grid h-9 w-11 place-items-center rounded-lg bg-gold text-poelse">
                            <HotdogIcon className="h-4 w-7" />
                        </span>
                        <span className="font-serif text-lg font-bold tracking-tight">Lej En Pølsevogn.dk</span>
                    </div>
                    <p className="mt-4 font-serif text-sm italic leading-relaxed text-paper/80">
                        "Et kald til chefen — du er klar. Få et tilbud og et hurtigt svar."
                    </p>
                    <div className="mt-5 space-y-2 text-sm text-paper/80">
                        <a data-testid="footer-phone" href={`tel:${CONTACT.phoneHref}`} className="flex items-center gap-2.5 transition-colors duration-200 hover:text-paper">
                            <Phone className="h-4 w-4" /> {CONTACT.owner} — {CONTACT.phone}
                        </a>
                        <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 transition-colors duration-200 hover:text-paper">
                            <Mail className="h-4 w-4" /> {CONTACT.email}
                        </a>
                        <p className="pl-6 font-mono text-xs text-paper/50">CVR {CONTACT.cvr}</p>
                    </div>
                    <div className="mt-6 flex flex-col gap-2.5">
                        <a
                            data-testid="footer-facebook-link"
                            href={SOCIAL.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center gap-2.5 text-sm font-semibold text-paper/85 transition-colors duration-200 hover:text-paper"
                        >
                            <span className="grid h-8 w-8 place-items-center rounded-full border border-paper/25 transition-[background-color,border-color] duration-200 group-hover:border-paper group-hover:bg-paper group-hover:text-poelse">
                                <Facebook className="h-4 w-4" />
                            </span>
                            Find os på Facebook
                        </a>
                        <a
                            data-testid="footer-instagram-link"
                            href={SOCIAL.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group inline-flex items-center gap-2.5 text-sm font-semibold text-paper/85 transition-colors duration-200 hover:text-paper"
                        >
                            <span className="grid h-8 w-8 place-items-center rounded-full border border-paper/25 transition-[background-color,border-color] duration-200 group-hover:border-paper group-hover:bg-paper group-hover:text-poelse">
                                <Instagram className="h-4 w-4" />
                            </span>
                            Find os på Instagram
                        </a>
                    </div>
                    <p className="mt-5 inline-flex items-center gap-2 rounded-full border border-paper/25 px-3 py-1.5 text-xs font-semibold">
                        <BadgeCheck className="h-4 w-4" />
                        Alle forespørgsler er 100% uforpligtende
                    </p>
                </div>
                <nav className="flex flex-col gap-3 font-mono text-xs uppercase tracking-[0.2em] text-paper/70">
                    <button data-testid="footer-link-menuer" onClick={() => onNavigate("menuer")} className="text-left transition-colors duration-200 hover:text-paper">
                        Menuer
                    </button>
                    <button data-testid="footer-link-vognen" onClick={() => onNavigate("vognen")} className="text-left transition-colors duration-200 hover:text-paper">
                        Vognen
                    </button>
                    <button data-testid="footer-link-faq" onClick={() => onNavigate("faq")} className="text-left transition-colors duration-200 hover:text-paper">
                        FAQ
                    </button>
                    <button data-testid="footer-cta" onClick={() => onNavigate("byg-din-event")} className="mt-2 w-fit rounded-full bg-gold px-5 py-2.5 font-sans text-sm font-bold normal-case tracking-normal text-poelse transition-[background-color,transform] duration-200 hover:bg-gold-deep active:scale-95">
                        Byg din forespørgsel →
                    </button>
                </nav>
            </div>
            <div className="border-t border-paper/15">
                <p className="mx-auto max-w-6xl px-5 py-5 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/50">
                    © 2026 Lej En Pølsevogn.dk — Mere end 25 års erfaring
                </p>
            </div>
        </footer>
    );
}
